import { Dayjs } from 'dayjs'
import { RoleType } from '../User'

const _ROOM_TYPES = ['CompanyMessageRoom', 'CompanyMessageGroupRoom'] as const
export type RoomType = typeof _ROOM_TYPES[number]

const _VISIBILITY_STATUS_TYPE = ['all', 'visible', 'hidden'] as const
export type VisibilityStatusType = typeof _VISIBILITY_STATUS_TYPE[number]

export const MATCHING_STATUSES_STR = [
  'all_room',
  'is_messaging',
  'matching_request',
]
export const MATCHING_STATUSES = [
  'all_room',
  'is_messaging',
  'matching_request',
] as const
export type MatchingStatusType = typeof MATCHING_STATUSES[number]

export type CreationSourceType = {
  sent_request_from_search?: boolean
  recieved_request_from_search?: boolean
  sent_request_from_request_box?: boolean
  recieved_request_from_request_box?: boolean
  sent_request_from_contribution?: boolean
  recieved_request_from_contribution?: boolean
  creation_source_is_referrer?: boolean
  creation_source_is_event?: boolean
  requested_from_other?: boolean
}

export const ROOM_STATUSES = [
  'unspecified',
  'unread_only',
  'has_memo',
  'hidden',
  'company_message_room',
  'company_message_group_room',
] as const
export type RoomStatusType = typeof ROOM_STATUSES[number]

export type RoomUniqueId = `r-${number}` | `g-${number}`

export type Room = {
  id: number
  uniqueId: RoomUniqueId
  counters: Counter[]
  url: string
  latestMessage?: {
    content: string
    sentAt: string
  }
  hasRead: boolean
  isRequestReceived: boolean
  isHidden: boolean
  hiddenUrl: string
  unhiddenUrl?: string | null
  isGroup: boolean
  type: RoomType
  firstMessageId: number | null
  new: boolean
  hasMemos: boolean
  triggerText: {
    receivedGuideMessageFlag?: boolean
    sendGuideMessageFlag?: boolean
    matchingDetailText?: string | null
    matchingDateText?: string | null
  }
  pinned: boolean
  unreadBatchMessageRoom: boolean
  customStatusId?: number | null
  createdAt: Dayjs
  createType: 'search' | 'request_box' | 'contribution'
  memoCount: number
  hasDeletedUser?: boolean
  feedbacked: boolean
  canFeedback: boolean
  firstMessageSentAt: Dayjs
  tagMappings: TagMapping[]
  urlForTimeline: string
}

export type Counter = {
  id: number
  name: string
  nameFurigana: string
  companyName: string
  position?: string | null
  iconSrc?: string | null
  isReferrer?: boolean
  role?: RoleType
  isAdminRole?: boolean
  isDeletedUser?: boolean
  messageAvailable?: boolean
  isPaidPlan?: boolean
  feedbackScore?: number
  feedbackCount?: number
}

export type TagMapping = {
  id: number
  roomType: RoomType
  roomId: number
  tagId: number
  tagName: string
}

export type FeedbackRoom = {
  id: number
  roomType: RoomType
  uniqueId: RoomUniqueId
  firstMessageSentAt: Dayjs
  counter: FeedbackCounter
}
export type AppointmentRoom = {
  id: number
  roomType: RoomType
  uniqueId: RoomUniqueId
  counter: AppointmentCounter
}

type OptionalCounter = 'isReferrer' | 'nameFurigana'

type FeedbackCounter = Omit<Counter, OptionalCounter> & {
  isPaidPlan: boolean
}

type AppointmentCounter = Omit<Counter, OptionalCounter> & {
  isPaidPlan: boolean
}
